/** API outpoints may be displayed as txid:vout or serialized little-endian bytes. */
export function normalizeOutpoint(value?: string | null): string | null {
	if (!value) return null
	if (/^[a-f\d]{64}:\d+$/i.test(value)) return value.toLowerCase()
	if (/^[a-f\d]{72}$/i.test(value)) {
		const txid = value.slice(0, 64).match(/../g)!.reverse().join('')
		const index = parseInt(value.slice(64).match(/../g)!.reverse().join(''), 16)
		return `${txid.toLowerCase()}:${index}`
	}
	return null
}

export function resolveItemListing(id: string, outpoint: any, listings: unknown, initial?: any) {
	const current = normalizeOutpoint(outpoint?.inscription?.outpoint)
	const eligible = (listing: any) => {
		if (
			!listing ||
			!Number.isSafeInteger(listing.satoshi_price) ||
			listing.satoshi_price <= 0 ||
			listing.bought_at ||
			listing.buyer_address
		)
			return false
		if (listing.inscription_id && listing.inscription_id !== id) return false
		if (outpoint?.owner && listing.seller_address && outpoint.owner !== listing.seller_address)
			return false
		const listed = normalizeOutpoint(listing.outpoint)
		return !(current && listed && current !== listed)
	}
	if (eligible(outpoint?.escrow)) return outpoint.escrow
	// A successful collection response supersedes the card's cached listing.
	if (Array.isArray(listings))
		return listings.find((l) => l.inscription_id === id && eligible(l)) ?? null
	return eligible(initial?.escrow) ? initial.escrow : null
}
